import React from 'react';

import Modal from 'ui-library/modals/Modal';

export default function AmendStepModal({
  onRequestClose,
  onRequestSubmit,
}: {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}): JSX.Element {
  return (
    <Modal
      title="Amend step"
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        onRequestSubmit();
      }}
      buttons={[
        {text: 'Submit', submit: true, dataTestAttrs: {component: 'AmendStepModal', element: 'submitButton'}},
      ]}
    >
      <span>
        Please note, previously submitted data <strong>will not be archived or removed</strong> from the
        system.
      </span>
    </Modal>
  );
}
